import { render, staticRenderFns } from "./EnvironmentSwitcher.vue?vue&type=template&id=49341165"
import script from "./EnvironmentSwitcher.vue?vue&type=script&lang=js"
export * from "./EnvironmentSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49341165')) {
      api.createRecord('49341165', component.options)
    } else {
      api.reload('49341165', component.options)
    }
    module.hot.accept("./EnvironmentSwitcher.vue?vue&type=template&id=49341165", function () {
      api.rerender('49341165', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainContent/EnvironmentSwitcher.vue"
export default component.exports